import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// 라우트 이동 시 페이지 스크롤을 상단으로 부드럽게 이동시키는 헬퍼

export default function NavigateScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // 부드러운 이동
    });
  }, [pathname]);

  return null;
}
